import {useEffect, useState} from "react";
import Hooks from "./utils/hooks";
import { useAppSelector } from "../redux/hooks";
import i18next from "i18next";
import { useLocation } from "react-router-dom";
import { ExportVideoModal } from "./ExportVideoModal";
import { useDispatch } from "react-redux";
import MediaNotfound from "../MediaNotfound";
import { AbonnementModal } from "./modals/abonnementModal";
import { MetaDataVideoModal } from "./modals/metadataVideoModal";
import { DetailsModal } from "./modals/detailModal";
import { EventHandler } from "../Medias/utils/event";
import { setVideoFile, setthumbsData } from "../addMedia/store/addMediaActions";
import DownloadModalFiles from "./modals/downloadModalFiles";
import VideoDetails from "./modals/VideoDetails";
import DeleteAudioDescription from "../AddAudioDescription/DeleteAudioDescription";
import "../App.css";
import { ShowCadenasModal } from "./modals/ShowCadenasModal";

function Media() {
  const { getMediaList, idVideo,nameVideo } = Hooks();
  const dispatch = useDispatch();
  const { EventListener } = EventHandler();
  const listMediaurl = useAppSelector((state) => state.MediaReducer.listVideos);
  const modalToOpen = useAppSelector((state) => state.MediaReducer.modalToOpen);
  const video = useAppSelector((state) => state.MediaReducer.urlVideo);

  const unautorizedMedia = useAppSelector(
    (state) => state.MediaReducer.unautorizedMedia
  );
  const mediaLoading = useAppSelector(
    (state) => state.MediaReducer.mediaLoading
  );
  const iframeKey = useAppSelector(state=>state.MediaReducer.iframeKey)
  const location = useLocation();
  const queryParam = new URLSearchParams(location.search);
  const [lang, setLang] = useState(
    queryParam.get("lang") || 
      (localStorage.getItem("i18nextLng") !== "null" &&
        localStorage.getItem("i18nextLng")) ||
      "fr"
  );
  const color = queryParam.get("color") || localStorage.getItem('color');
  const size = queryParam.get("size");
  const filter = queryParam.get("videos");
  const [dark, setDark] = useState(queryParam.get("dark"));

  const [key, setKey] = useState(false);

  // Listen for dark theme updates from parent window (like App.js does)
  useEffect(() => {
    const handleThemeMessage = (event) => {
      if (event.data && event.data.info === 'updateTheme') {
        const theme = event.data.theme;
        setDark(theme === 'dark' ? 'true' : 'false');
      }
      if (event.data && event.data.info === 'clearTheme') {
        setDark(null);
      }
    };

    window.addEventListener('message', handleThemeMessage);
    
    // Also check localStorage for theme (set by App.js)
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setDark('true');
    }

    return () => {
      window.removeEventListener('message', handleThemeMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setthumbsData({}))
    dispatch(setVideoFile(""))
    getMediaList();
    EventListener();
    window.parent.postMessage({info:"diffusion",value:"ongoing"}, "*")
    window.addEventListener("message", function (event) {
        if (event.data?.info === "updateLang") {
            setLang(event.data.lang)
            i18next.changeLanguage(event.data.lang)
            localStorage.setItem("lang", event.data.lang)
        } else if (event.data && event.data.info && event.data.info === "videoDeletedSuccessfully") {
            setKey(iframeKey + 1);
        }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(iframeKey) {
        setKey(iframeKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeKey]);

  // Build dynamic URL parameters
  const urlParams = new URLSearchParams();
  if (lang) urlParams.set('lang', lang);
  if (color) urlParams.set('color', color);
  if (size) urlParams.set('size', size);
  if (filter) urlParams.set('videos', filter);
  if (dark != null) urlParams.set('dark', dark);
  urlParams.set('output', 'embed');
  
  const queryString = urlParams.toString();
  
  // Use listMediaurl if available, otherwise fallback to hardcoded URL
  const iframeSrc =  listMediaurl + queryString;

  return (
    <div>
      {!mediaLoading && unautorizedMedia ? (
        <MediaNotfound />
      ) : (
        <div>
            <iframe
              title={listMediaurl}
              className="iframe-video"
              id="iframe_list"
              allowFullScreen=""
              frameBorder="0"
              key={key}
              src={iframeSrc}
              ></iframe>
              {modalToOpen && modalToOpen === "showModalExport" && <ExportVideoModal video={video} idVideo={idVideo}/>}            
              {modalToOpen && modalToOpen === "showVideoDetail" && <MetaDataVideoModal video={video} idVideo={idVideo} nameVideo={nameVideo}/>}         
              {modalToOpen && modalToOpen === "addSubscribers" && <AbonnementModal video={video} idVideo={idVideo}/>}   
              {modalToOpen && modalToOpen === "showModalForDownloadVideos" && <DownloadModalFiles video={video} idVideo={idVideo} />}
              {modalToOpen && modalToOpen.type && modalToOpen.type === "showListAction" && <DetailsModal />}
              {modalToOpen === "showModalForDetailVideo" && (<VideoDetails idVideo={idVideo} />)}
              {modalToOpen === "showCadenasModal" && (<ShowCadenasModal video={video} idVideo={idVideo} />)}
              {modalToOpen === "deleteDescription" && (<DeleteAudioDescription  video={video} idVideo={idVideo}/>)}
          </div>
          )}
    </div>
  );
}

export default Media;
